import type { PaginatedResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import { plantContractsEndpoints, plantsEndpoints } from "@/app/api/endpoints";
import type { PlantContractRef, PlantRef } from "../types";

/**
 * Lightweight ref services for the planting form's Selects.
 * No dedicated frontend module exists for plants / plant-contracts.
 */
export const plantRefsService = {
	async listPlants(organizationId: string): Promise<PaginatedResponse<PlantRef>> {
		const response = await apiClient.get<PaginatedResponse<PlantRef>>(plantsEndpoints.list, {
			params: { organizationId, limit: 100 },
		});
		return response.data;
	},

	async listContracts(organizationId: string): Promise<PaginatedResponse<PlantContractRef>> {
		const response = await apiClient.get<PaginatedResponse<PlantContractRef>>(
			plantContractsEndpoints.list,
			{ params: { organizationId, limit: 100 } }
		);
		return response.data;
	},
};
